import { Pagination } from "antd";
import styled from "styled-components";

export const StyledPagination = styled(Pagination)`
  &.task-eva-ui--pagination {
    .ant-pagination-prev,.ant-pagination-next {
      height: 24px;
    }
    .ant-pagination-item-link {
      width: 24px;
      height: 24px;
      min-width: 24px;
      line-height: 24px;
      &:hover {
        border-radius: 4px;
        background: #1A1C1F;
      }
    }
    .ant-pagination-item {
      background: unset;
      border-radius: 4px;
      border: 0;
      width: 24px;
      height: 24px;
      min-width: 24px;
      line-height: 24px;
      &:hover {
        background: #1A1C1F !important;
        color: #E0EDEF !important;
      }
      &.ant-pagination-item-active {
        border: 1px solid var(--main-color);
      }
      a {
        font-weight: 400;
        color: #E0EDEF !important;
      }
    }
    .ant-pagination-item-link svg {
      color: #666666;
      &:hover {
        color: var(--main-color);
      }
    }
    .ant-pagination-options .ant-select:not(.ant-select-customize-input) .ant-select-selector {
      background: unset;
      border-radius: 4px;
      border: 1px solid #595B61 !important;
      color: #E0EDEF;
    }
  }
`;
